module.exports = __webpack_public_path__ + "img/money-check-pen.27b32c38.svg";